import React, { useState } from 'react';

import SurveyAnswerComments from 'components/comment/surveyComments';

const INITIAL_COMMENTS_COUNT = 15;
const INCREMENT_COUNT = 30;

const CommentAnswers = ({ comments }) => {
  const [displayCount, setDisplayCount] = useState(
    Math.min(comments.length, INITIAL_COMMENTS_COUNT)
  );
  const displayComments = [...comments].splice(0, displayCount);
  const loadMore = () => {
    const count = Math.min(displayCount + INCREMENT_COUNT, comments.length);
    setDisplayCount(count);
  };
  const allCommentsDisplayed = displayCount >= comments.length;
  const btnClassname = allCommentsDisplayed ? `d-none` : 'd-block';
  return (
    <div className="survey-nps-report p-4">
      <SurveyAnswerComments comments={displayComments} />
      <div className="d-flex flex-row justify-content-center">
        <button
          type="button"
          className={`btn btn-primary ${btnClassname}`}
          disabled={displayCount >= comments.length}
          onClick={loadMore}
        >
          Load More
        </button>
      </div>
    </div>
  );
};

export default CommentAnswers;



// WEBPACK FOOTER //
// ./src/components/reports/comment/commentAnswers.js